<div class="header-container">
  <div class="logo-container">
    <a
      matRipple
      href="#"
      class="sidebar-toggle"
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleSidebar()"
    >
      <nb-icon [icon]="isMaterialTheme() ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">{{ headerData.headerBrandTitle }} </a>
  </div>
  <nb-select
    matRipple
    status="primary"
    [selected]="currentThemeService.currentThemeSignal()"
    class="theme-select"
    (selectedChange)="changeTheme($event)"
  >
    <nb-option *ngFor="let theme of themes" [value]="theme.value" matRipple>{{ theme.name }}</nb-option>
  </nb-select>
</div>

<div class="header-container">
  <nb-actions size="small">
    @for (templateRef of templateRefs; track $index) {
      <!-- *ngFor="let templateRef of templateRefs" -->
      <nb-action
        matRipple
        [class]="templateRef.actionType"
        [icon]="templateRef.icon || ''"
        [nbTooltipDisabled]="!!(templateRef.tootltip?.text || templateRef.action?.config?.title)"
        [nbTooltip]="templateRef.tootltip?.text || templateRef.action?.config?.title || '__ACTION__'"
        [nbTooltipPlacement]="templateRef.tootltip?.position || 'bottom'"
        (click)="onAction(templateRef)"
      >
        @if (templateRef.actionType === 'search') {
          <!-- *ngIf="templateRef.actionType === 'search'" -->
          <nb-search
            matRipple
            type="rotate-layout"
            [matRippleUnbounded]="true"
            [matRippleCentered]="true"
            (click)="startSearch()"
          ></nb-search>
        } @else if (templateRef.actionType === 'user' && templateRef.user) {
          <nb-user
            cdkOverlayOrigin
            [name]="templateRef.user.name"
            [onlyPicture]="userPictureOnly"
            [picture]="templateRef.user.picture"
            [matMenuTriggerFor]="userMenu"
            #userMenuTrigger="matMenuTrigger"
            (click)="isOpen = !isOpen"
          >
          </nb-user>
          <mat-menu #userMenu="matMenu" class="customize" panelClass="customize-panel" backdropClass="customize">
            <div class="user-menu">
              <div class="float-user-container-user">
                <h6>User Profile</h6>
                <div>
                  <img [src]="templateRef.user.picture" width="95" />
                  <div class="user-info">
                    <h6>{{ templateRef.user.name }}</h6>
                    @if (templateRef.user.type) {
                      <span>
                        <nb-icon icon="checkmark-circle-outline" pack="eva"></nb-icon>
                        Verified
                      </span>
                    } @else {
                      <span>
                        <nb-icon icon="close-circle-outline" pack="eva"></nb-icon>
                        Unverified
                      </span>
                    }
                    <span>
                      <nb-icon icon="email-outline" pack="eva"></nb-icon>
                      {{ templateRef.user.email }}
                    </span>
                  </div>
                </div>
              </div>

              <mat-divider></mat-divider>

              <div class="float-user-container-user-menu">
                @for (menuItem of getMenuitems; track $index) {
                  <!-- The whole row navigates, not just the icon: the title and subtitle are what
                       a user actually aims at, and the icon is decorative. `menuItem.link` was
                       configured all along and simply never bound to anything. -->
                  <div
                    class="user-menu-item"
                    role="link"
                    [routerLink]="menuItem.link"
                    (click)="userMenuTrigger.closeMenu()"
                  >
                    <button nbButton type="button" [routerLink]="menuItem.link">
                      @if (menuItem.icon) {
                        <nb-icon [config]="menuItem.icon"></nb-icon>
                      }
                    </button>
                    <div>
                      <h5>{{ menuItem.title }}</h5>
                      <span>{{ menuItem.data }}</span>
                    </div>
                  </div>
                }
              </div>
              <!-- Was inert. Both shells route sign-out through NbLogoutComponent at /auth/logout,
                   which is deliberately the one auth child without the anonymous-only guard. -->
              <button
                nbButton
                outline
                status="primary"
                type="button"
                routerLink="/auth/logout"
                (click)="userMenuTrigger.closeMenu()"
              >
                Logout
              </button>
            </div>
          </mat-menu>
        }
      </nb-action>
    }
  </nb-actions>
</div>
